module.exports = __webpack_public_path__ + "static/laboheme7s-a817c927d2d8646feb8a58dcde7d13c5.jpg";